/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockDetailExportDto } from './StockDetailExportDto';
import {
    StockDetailExportDtoFromJSON,
    StockDetailExportDtoFromJSONTyped,
    StockDetailExportDtoToJSON,
    StockDetailExportDtoToJSONTyped,
} from './StockDetailExportDto';

/**
 * 
 * @export
 * @interface ResponseListStockDetailExportDto
 */
export interface ResponseListStockDetailExportDto {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListStockDetailExportDto
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListStockDetailExportDto
     */
    message?: string;
    /**
     * 
     * @type {Array<StockDetailExportDto>}
     * @memberof ResponseListStockDetailExportDto
     */
    data?: Array<StockDetailExportDto>;
}

/**
 * Check if a given object implements the ResponseListStockDetailExportDto interface.
 */
export function instanceOfResponseListStockDetailExportDto(value: object): value is ResponseListStockDetailExportDto {
    return true;
}

export function ResponseListStockDetailExportDtoFromJSON(json: any): ResponseListStockDetailExportDto {
    return ResponseListStockDetailExportDtoFromJSONTyped(json, false);
}

export function ResponseListStockDetailExportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListStockDetailExportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(StockDetailExportDtoFromJSON)),
    };
}

export function ResponseListStockDetailExportDtoToJSON(json: any): ResponseListStockDetailExportDto {
    return ResponseListStockDetailExportDtoToJSONTyped(json, false);
}

export function ResponseListStockDetailExportDtoToJSONTyped(value?: ResponseListStockDetailExportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(StockDetailExportDtoToJSON)),
    };
}

